import React from "react";
import DND from "../pages/canvas/paper/dndhandler";
import Render from "../pages/canvas/paper/render";

export default function Row(props) {
  return (
    <div
      style={{
        position: "absolute",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        backgroundColor: props.block.props.overlay,
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        visibility: props.block.hidden ? "hidden" : "unset",
        zIndex: 5,
      }}
    >
      <div
        ref={props.editorRef}
        style={{
          display: "flex",
          flexWrap: "wrap",
          position: "relative",
          boxSizing: "border-box",
          width: "100%",
          overflowY: "scroll",

          flexGrow: props.block.props.flexGrow,
          backgroundColor: props.block.props.backgroundColor,
          justifyContent: props.block.props.justifyContent,
          alignItems: props.block.props.alignItems,
          boxShadow: props.block.props.boxShadow,
          ...props.block.props.size,
          ...props.block.props.border,
          ...props.block.props.spacing,
        }}
      >
        {props.children.map((block, index) => {
          const newPath = [...props.path];
          newPath.push(index);

          return (
            <DND
              key={block.id}
              disabled={props.disabled}
              block={block}
              path={newPath}
              index={index}
            >
              <Render />
            </DND>
          );
        })}
      </div>
    </div>
  );
}
